// tslint:disable:max-line-length
import * as React from 'react'
import { connect } from 'react-redux'

import SignupForm from '../../pages/landing/components/SignupForm'

import { Text } from '@doordash/design-language'

import DrivingOpportunitiesDescription from '../../molecules/driving-opportunities-job-description'
import DrivingOpportunitiesJobList from '../../molecules/driving-opportunities-job-list'
import DrivingOpportunitiesTopCities from '../../molecules/driving-opportunities-top-cities'

import { BASE_PATH } from '../../../constants'
import Breadcrumbs from '../../atoms/breadcrumbs'
import DrivingOpportunitiesHero from '../../organisms/driving-opportunities-hero'
import Simple from '../../templates/simple'
import { SimpleStyleType } from '../../templates/simple/constants'
import {
  HOME_DESCRIPTION_CONTENT,
  HOME_DESCRIPTION_TITLE,
  PageTypes,
} from './constants'
import {
  BreadcrumbsContainer,
  FormContainer,
  HomeDescriptionContainer,
  HomeDescriptionStack,
  JobSectionContainer,
} from './styles'

import * as events from '../../../events'
import { IOpportunityData } from './types'

interface ISettings {
  FB_ID: string
  NR_LICENSE_KEY: string
  NR_APP_ID: string
  DATE_POSTED: string
  DATE_POSTED_FULL: string
  VALID_THROUGH: string
}

type Props = {
  trackDrivingOpportunitiesRendered?: (object) => Promise<any>
  slug: string
  cityState: string
  jobType: string
  data: IOpportunityData
  settings: ISettings
}

const HomeDescription = () => (
  <HomeDescriptionContainer>
    <HomeDescriptionStack>
      <Text styles={Text.Styles.MajorPageTitle}>{HOME_DESCRIPTION_TITLE}</Text>
      <Text styles={Text.Styles.PageDescriptionBody}>
        {HOME_DESCRIPTION_CONTENT}
      </Text>
    </HomeDescriptionStack>
  </HomeDescriptionContainer>
)

const PageBreadcrumbs = ({ cityState, slug, jobType, jobTypeName }) => {
  const cityName = cityState || slug
  const jobName = jobTypeName || jobType
  const cityRoutes = [
    { path: '/dasher/signup/', breadcrumb: 'Signup' },
    { path: `${BASE_PATH}/`, breadcrumb: 'Driving opportunities' },
    { path: `${BASE_PATH}/${slug}/`, breadcrumb: `${cityName}` },
  ]

  const jobRoutes = [
    { path: '/dasher/signup/', breadcrumb: 'Signup' },
    { path: `${BASE_PATH}/`, breadcrumb: 'Driving opportunities' },
    { path: `${BASE_PATH}/${slug}/`, breadcrumb: `${cityName}` },
    {
      path: `${BASE_PATH}/${slug}/${jobType}`,
      breadcrumb: `${jobName} opportunity`,
    },
  ]

  return jobType ? (
    <Breadcrumbs routes={jobRoutes} />
  ) : (
    <Breadcrumbs routes={cityRoutes} />
  )
}

const RootBreadcrumbs = () => {
  const routes = [
    { path: '/dasher/signup/', breadcrumb: 'Signup' },
    { path: `${BASE_PATH}/`, breadcrumb: 'Driving opportunities' },
  ]

  return <Breadcrumbs routes={routes} />
}

const headerButton = {
  href: `${BASE_PATH}/`,
  title: 'See all opportunities',
}

export class DrivingOpportunities extends React.Component<Props> {
  public componentDidMount() {
    const { data } = this.props

    const { JOB_TYPE, CITY } = data
    const { JobPage, CityPage, LandingPage } = PageTypes

    // null comes from the template as a string
    const pageType =
      JOB_TYPE && JOB_TYPE !== 'null' ? JobPage : CITY ? CityPage : LandingPage

    const payload: events.PageTrackingProps = {
      pageType,
      data,
    }

    this.props.trackDrivingOpportunitiesRendered(payload)
  }

  public render() {
    const { cityState, jobType, slug, data, settings } = this.props
    return (
      <div style={{ overflowX: 'hidden' }}>
        <Simple
          includeFooter={true}
          headerIsDark={false}
          headerButton={slug ? headerButton : null}
          isMobile={true}
          type={SimpleStyleType.Standard}
        >
          <DrivingOpportunitiesHero
            cityState={data.CITY_STATE}
            jobType={jobType}
            datePosted={settings.DATE_POSTED_FULL}
          />
          <FormContainer>
            <SignupForm isContained />
          </FormContainer>
          <BreadcrumbsContainer>
            {slug ? (
              <PageBreadcrumbs
                cityState={data.CITY_STATE}
                slug={slug}
                jobType={jobType}
                jobTypeName={data.JOB_TYPE_NAME}
              />
            ) : (
              <RootBreadcrumbs />
            )}
          </BreadcrumbsContainer>
          {!cityState && <HomeDescription />}
          <JobSectionContainer>
            {!jobType && (
              <DrivingOpportunitiesJobList
                cityState={data.CITY_STATE}
                slug={slug}
              />
            )}
            {}
            {jobType && (
              <DrivingOpportunitiesDescription
                city={data.CITY}
                jobTypeName={data.JOB_TYPE_NAME}
              />
            )}
          </JobSectionContainer>
          {!jobType && <DrivingOpportunitiesTopCities />}
        </Simple>
      </div>
    )
  }
}

export const DisconnectedDrivingOpportunities = DrivingOpportunities

const mapDispatchToProps = {
  trackDrivingOpportunitiesRendered: events.trackDrivingOpportunitiesRendered,
}

export default connect(null, mapDispatchToProps)(DrivingOpportunities)
